import React from "react";
import {
  Badge,
  ComponentMultiStyleConfig,
  HStack,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type CMIndicatorStatusProps = {
  label?: string;

  /**
   * ラベルとステータスバッジの区切り文字に使用
   */
  separator?: string;

  badgeText?: string;

  /**
   * バッジの色
   * chakra-uiのtheme.colorsに存在する色を指定可能
   */
  badgeColor?: string;

  /**
   * バッジのスタイル設定に使用
   */
  variant?: "subtle" | "solid" | "outline";
} & ComponentStyleProps;

/**
 * 状態インジケータを表示するコンポーネント
 */
export const CMIndicatorStatus = ({
  label,
  separator = ":",
  badgeText,
  badgeColor,
  variant = "solid",

  sx,
  ...rest
}: CMIndicatorStatusProps) => {
  const styles = useMultiStyleConfig("CMIndicatorStatusStyles");

  return (
    <HStack sx={{ ...styles.container, ...sx }} spacing={0} {...rest}>
      <Text sx={styles.text}>{label}</Text>
      <Text sx={styles.separator}>{separator}</Text>
      <Badge colorScheme={badgeColor} variant={variant} sx={styles.badge}>
        <Text sx={styles.badgeText}> {badgeText}</Text>
      </Badge>
    </HStack>
  );
};

export const CMIndicatorStatusStyles: ComponentMultiStyleConfig = {
  parts: ["container", "text", "separator", "badge", "badgeText"],
  baseStyle: {
    container: {
      w: "max-content",
    },
    text: {
      fontWeight: "400",
      fontSize: "12px",
      color: "gray.500",
      whiteSpace: "nowrap",
    },
    separator: {
      pl: "4px",
      pr: "4px",
      fontWeight: "400",
      fontSize: "12px",
      color: "gray.500",
      whiteSpace: "nowrap",
    },
    badge: {
      maxW: "200px",

      borderRadius: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "700",

      px: "10px",
      whiteSpace: "nowrap",
    },
    badgeText: {
      overflow: "hidden",
      textOverflow: "ellipsis",

      fontSize: "12px",
      lineHeight: "16px",
    },
  },
};
